// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ix-0";
export var fileCarousel = "_ix-2";
export var removeFileButton = "_ix-1";